import { createSlice } from "@reduxjs/toolkit";
import { getCommentList } from "./thunk";

export interface IState {
  lstComment: any;
  isCommentLoading: boolean;
  isCommentSuccess: boolean;

  error: any;
}

export const initialState: IState = {
  lstComment: null,
  isCommentLoading: false,
  isCommentSuccess: false,

  error: {},
};

const AgencySlice = createSlice({
  name: "Agency",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCommentList.pending, (state: IState, action: any) => {
      state.isCommentLoading = true;
    });
    builder.addCase(
      getCommentList.fulfilled,
      (state: IState, action: any) => {
        state.lstComment = action.payload.data;
        state.isCommentSuccess = true;
        state.isCommentLoading = false;
      }
    );
    builder.addCase(
      getCommentList.rejected,
      (state: IState, action: any) => {
        state.error = action.payload.error || null;
        state.isCommentSuccess = false;
        state.isCommentLoading = false;
      }
    );
  },
});

export default AgencySlice.reducer;